import { normalizeRegion, normalizeDistrict } from '../functions/normalize';
import { getCommunityInfo } from '../functions/community-operations';
import { sortArrayByField } from './community-operations';

export const getNormalizedArray = rawArray => {
  const array = [];

  rawArray.forEach(region => {
    const currentRegion = {
      regionName: normalizeRegion(region.reg.name),
      districts: [],
    };

    const currentDistricts = region.districts;

    currentDistricts.forEach(district => {
      const currentDistrict = {
        districtName: normalizeDistrict(district.dist.name),
        communities: [],
      };

      const currentCommunities = district.communities;

      currentCommunities.forEach(community => {
        const currentCommunity = getCommunityInfo(community);
        currentDistrict.communities.push(currentCommunity);
      });

      //   sort
      sortArrayByField(currentDistrict.communities, 'name');

      currentRegion.districts.push(currentDistrict);
    });

    // sort
    sortArrayByField(currentRegion.districts, 'districtName');

    array.push(currentRegion);
  });

  // sort
  sortArrayByField(array, 'regionName');

  return array;
};
